import * as api from '../businessEntityApi';
import { businessEntityActionCreators, BusinessEntityActionKeys, SearchBusinessEntities } from '..';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import { IBusinessEntityMin } from '../businessEntityInterfaces';
import { IState } from '../..';

function* searchBusinessEntitiesSaga(action: SearchBusinessEntities) {
  const typeString = `${action.payload.type}_${action.payload.zipcode}`;
  yield put(businessEntityActionCreators.toggleSearchLoading(typeString));
  const current = yield select((state: IState) => state.businessEntity.search[typeString]);

  // TODO cache invalidation
  if (!current) {
    try {
      const results: IBusinessEntityMin[] = yield call(api.Search, action.payload);
      yield put(businessEntityActionCreators.setSearchResults(typeString, results));
    } catch {
      //
    }
  }

  yield put(businessEntityActionCreators.toggleSearchLoading(typeString));
}

export function* watchSearchBusinessEntities() {
  yield takeEvery(BusinessEntityActionKeys.SEARCH_BUSINESS_ENTITIES, searchBusinessEntitiesSaga);
}
